
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import BtnRadio from "@common/src/components/scope/btn-radio/index.vue";
import echarts from "echarts";
import dayjs from "dayjs";
import { addCurrencyUnit } from "@common/src/utils/tools";
import t from "@common/src/i18n/t";

const finance = namespace("finance");

@Component({
  components: { BtnRadio }
})
export default class ReportOutputValue extends Vue {
  @finance.Action getItemProductionValue;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  formData: any = {
    statisticMethod: "1",
    statisticDate: ""
  };
  myChart: any;
  nowDate: any = dayjs();
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.$refs.outputPie && (this.myChart = echarts.init(this.$refs.outputPie));
  }
  created() {
    this.formData.statisticDate = this.nowDate.format("YYYYMMDD");
    this.init();
  }
  init() {
    this.loadServerData();
  }
  normalizeRankingListProportion(rankingList = []) {
    if (!rankingList.length || rankingList.length > 9) {
      return rankingList;
    }
    const proportionList = rankingList.map(item => {
      const proportion = Number(item.productionValueProportion);
      return Math.max(isNaN(proportion) ? 0 : Math.round(proportion * 10000), 0);
    });
    const totalBasisPoint = proportionList.reduce((total, proportion) => total + proportion, 0);
    const diff = 10000 - totalBasisPoint;
    if (diff > 0) {
      proportionList[0] += diff;
    } else if (diff < 0) {
      const firstProportion = proportionList[0] + diff;
      if (firstProportion >= 0) {
        proportionList[0] = firstProportion;
      }
    }
    rankingList.forEach((item, index) => {
      item.productionValueProportion = proportionList[index] / 10000;
    });
    return rankingList;
  }
  draw(serverData?) {
    let nameArr = [];
    let valueArr = [];
    serverData.data.rankingList &&
      serverData.data.rankingList.forEach(item => {
        nameArr.push(item.serviceName);
        valueArr.push({
          name: item.serviceName,
          value: Number(item.productionValue),
          productionValueProportion: item.productionValueProportion
        });
      });
    nameArr.push(t("base.ohter"));
    if (serverData.data.other) {
      valueArr.push({
        name: t("base.ohter"),
        value: Number(serverData.data.other.productionValue),
        productionValueProportion: serverData.data.other.productionValueProportion
      });
    }
    const formatAmount = value => {
      const amount = Number(value || 0);
      return splitThousands((isNaN(amount) ? 0 : amount).toFixed(2));
    };
    const formatProportion = (value, fallback) => {
      if (value === null || value === undefined || value === "") {
        return `${fallback}%`;
      }
      const proportion = Number(value);
      return `${(isNaN(proportion) ? 0 : proportion * 100).toFixed(2)}%`;
    };
    let options = {
      tooltip: {
        trigger: "item",
        formatter: params => {
          return `${params.name}<br/>${t("finance.item-output-value")}: ${
            this.$localMark.currencySymbol + splitThousands(params.value)
          }(${formatProportion(params.data.productionValueProportion, params.percent)})`;
        }
      },
      legend: [
        {
          icon: "rect ",
          x: "center",
          bottom: 160,
          itemWidth: 12,
          itemHeight: 12,
          itemGap: 20,
          data: nameArr.slice(0, 4)
        }
      ],
      color: [
        "#2278F5",
        "#599AFA",
        "#00B478",
        "#5FC71A",
        "#FEBC00",
        "#FF9900",
        "#FE7000",
        "#F74E3B",
        "#E20568",
        "#8543E0",
        "#5D7092"
      ],
      graphic: [
        {
          //环形图中间添加文字
          type: "text", //通过不同top值可以设置上下显示
          left: "center",
          top: "25%",
          zlevel: 222,
          style: {
            text: addCurrencyUnit(t("finance.item-output-value-currency"), false, true),
            textAlign: "center",
            fill: "rgba(0, 0, 0, 0.45)",
            width: 30,
            height: 30,
            fontSize: 20
          }
        },
        {
          //环形图中间添加文字
          id: "totalProductionValue",
          type: "text", //通过不同top值可以设置上下显示
          left: "center",
          top: "30%",
          style: {
            text: formatAmount(serverData.data.totalProductionValue),
            textAlign: "center",
            width: 30,
            height: 30,
            fontSize: 20
          }
        }
      ],
      series: [
        {
          name: t("finance.access-source"),
          type: "pie",
          radius: ["30%", "50%"],
          center: ["50%", "30%"],
          avoidLabelOverlap: false,
          label: {
            show: false
          },
          emphasis: {
            label: {
              show: false,
              fontSize: "30",
              fontWeight: "bold"
            }
          },
          labelLine: {
            show: false
          },
          data: valueArr
        }
      ]
    };
    // 绘制图表
    this.myChart.setOption(options);
    const getSelectedTotal = selected => {
      return valueArr.reduce((total, item) => {
        if (selected && selected[item.name] === false) {
          return total;
        }
        const value = Number(item.value || 0);
        return total + (isNaN(value) ? 0 : value);
      }, 0);
    };
    this.myChart.off("legendselectchanged");
    this.myChart.on("legendselectchanged", params => {
      this.myChart.setOption({
        graphic: [
          {
            id: "totalProductionValue",
            style: {
              text: formatAmount(getSelectedTotal(params.selected))
            }
          }
        ]
      });
    });
  }
  handleDateChange() {
    this.loadServerData();
  }
  handleDateTypeChange() {
    if (this.formData.statisticMethod === "1") {
      this.formData.statisticDate = this.nowDate.format("YYYYMMDD");
    } else {
      this.formData.statisticDate = this.nowDate.format("YYYYMM");
    }
    this.loadServerData();
  }
  serverData: any = { data: { rankingList: [] } };
  loadServerData() {
    console.log(444, this.formData.statisticDate);
    this.getItemProductionValue(this.formData).then(data => {
      console.log("data", data);
      this.normalizeRankingListProportion(data.data.rankingList);
      this.serverData = data;
      data.data.rankingList.length && this.draw(data);
    });
  }
}
